import axios from "axios";
import { setSnackbar } from "../../../modules/snackbar/api/snackbar";
import { GET, DEL } from "../../genericAPI/api/actions";

export const GET_COMPLAINTS_REQUEST = "COMPLAINT/GET_COMPLAINTS_REQUEST";
export const GET_COMPLAINTS_RESPONSE = "COMPLAINT/GET_COMPLAINTS_RESPONSE";
export const GET_COMPLAINTS_FAILURE = "COMPLAINT/GET_COMPLAINTS_FAILURE";

export const GET_COMPLAINT_SLA_BADGES_RESPONSE =
  "COMPLAINT/GET_COMPLAINT_SLA_BADGES_RESPONSE";

export const GET_ACCOUNT_COMPLAINTS_REQUEST = "COMPLAINT/GET_ACCOUNT_COMPLAINTS_REQUEST";
export const GET_ACCOUNT_COMPLAINTS_RESPONSE = "COMPLAINT/GET_ACCOUNT_COMPLAINTS_RESPONSE";
export const GET_ACCOUNT_COMPLAINTS_FAILURE = "COMPLAINT/GET_ACCOUNT_COMPLAINTS_FAILURE";

export const UPDATE_COMPLAINT_REQUEST = "COMPLAINT/UPDATE_COMPLAINT_REQUEST";
export const UPDATE_COMPLAINT_RESPONSE = "COMPLAINT/UPDATE_COMPLAINT_RESPONSE";
export const UPDATE_COMPLAINT_FAILURE = "COMPLAINT/UPDATE_COMPLAINT_FAILURE";

export const CREATE_COMPLAINT_REQUEST = "COMPLAINT/CREATE_COMPLAINT_REQUEST";
export const CREATE_COMPLAINT_RESPONSE = "COMPLAINT/CREATE_COMPLAINT_RESPONSE";
export const CREATE_COMPLAINT_FAILURE = "COMPLAINT/CREATE_COMPLAINT_FAILURE";

export const DELETE_COMPLAINT_REQUEST = "COMPLAINT/DELETE_COMPLAINT_REQUEST";
export const DELETE_COMPLAINT_RESPONSE = "COMPLAINT/DELETE_COMPLAINT_RESPONSE";
export const DELETE_COMPLAINT_FAILURE = "COMPLAINT/DELETE_COMPLAINT_FAILURE";

export const GET_COMPLAINT_NOTES_REQUEST = "COMPLAINT/GET_COMPLAINT_NOTES_REQUEST";
export const GET_COMPLAINT_NOTES_RESPONSE = "COMPLAINT/GET_COMPLAINT_NOTES_RESPONSE";
export const GET_COMPLAINT_NOTES_FAILURE = "COMPLAINT/GET_COMPLAINT_NOTES_FAILURE";

export const CREATE_COMPLAINT_NOTE_REQUEST = "COMPLAINT/CREATE_COMPLAINT_NOTE_REQUEST";
export const CREATE_COMPLAINT_NOTE_RESPONSE = "COMPLAINT/CREATE_COMPLAINT_NOTE_RESPONSE";
export const CREATE_COMPLAINT_NOTE_FAILURE = "COMPLAINT/CREATE_COMPLAINT_NOTE_FAILURE";

export const GET_COMPLAINT_FILES_REQUEST = "COMPLAINT/GET_COMPLAINT_FILES_REQUEST";
export const GET_COMPLAINT_FILES_RESPONSE = "COMPLAINT/GET_COMPLAINT_FILES_RESPONSE";
export const GET_COMPLAINT_FILES_FAILURE = "COMPLAINT/GET_COMPLAINT_FILES_FAILURE";

export const CREATE_COMPLAINT_FILE_REQUEST = "COMPLAINT/CREATE_COMPLAINT_FILE_REQUEST";
export const CREATE_COMPLAINT_FILE_RESPONSE = "COMPLAINT/CREATE_COMPLAINT_FILE_RESPONSE";
export const CREATE_COMPLAINT_FILE_FAILURE = "COMPLAINT/CREATE_COMPLAINT_FILE_FAILURE";

export const DELETE_COMPLAINT_FILE_REQUEST = "COMPLAINT/DELETE_COMPLAINT_FILE_REQUEST";
export const DELETE_COMPLAINT_FILE_RESPONSE = "COMPLAINT/DELETE_COMPLAINT_FILE_RESPONSE";
export const DELETE_COMPLAINT_FILE_FAILURE = "COMPLAINT/DELETE_COMPLAINT_FILE_FAILURE";

export const GET_COMPLAINT_STATUSES_REQUEST = "COMPLAINT/GET_COMPLAINT_STATUSES_REQUEST";
export const GET_COMPLAINT_STATUSES_RESPONSE = "COMPLAINT/GET_COMPLAINT_STATUSES_RESPONSE";
export const GET_COMPLAINT_STATUSES_FAILURE = "COMPLAINT/GET_COMPLAINT_STATUSES_FAILURE";

export const GET_COMPLAINT_TYPES_REQUEST = "COMPLAINT/GET_COMPLAINT_TYPES_REQUEST";
export const GET_COMPLAINT_TYPES_RESPONSE = "COMPLAINT/GET_COMPLAINT_TYPES_RESPONSE";
export const GET_COMPLAINT_TYPES_FAILURE = "COMPLAINT/GET_COMPLAINT_TYPES_FAILURE";

export const SET_ACCOUNT_COMPLAINTS = "COMPLAINT/SET_ACCOUNT_COMPLAINTS";

export function setAccountComplaints(newAccountComplaints) {
  return { type: SET_ACCOUNT_COMPLAINTS, newAccountComplaints };
}

export function getComplaintsByAccountUuid(accountUuid) {
  return GET("complaint/by-account", accountUuid, GET_ACCOUNT_COMPLAINTS_REQUEST, GET_ACCOUNT_COMPLAINTS_RESPONSE, GET_ACCOUNT_COMPLAINTS_FAILURE);
}

export function deleteComplaint(uuid) {
  return DEL("complaint", uuid, DELETE_COMPLAINT_REQUEST, DELETE_COMPLAINT_RESPONSE, DELETE_COMPLAINT_FAILURE);
}

/** Normalize query params for GET /complaints (omit empty strings). */
function complaintListParams(raw = {}) {
  const out = {};
  Object.keys(raw).forEach((k) => {
    const v = raw[k];
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

/**
 * Fetch paginated / filtered complaints from the server.
 * @param {object|boolean} paramsOrLoading - Query params object, or legacy `false` to skip loading spinner.
 * @param {boolean} [maybeLoading]
 */
export function getComplaints(paramsOrLoading, maybeLoading) {
  let params = {};
  let isLoading = true;
  if (typeof paramsOrLoading === "boolean") {
    isLoading = paramsOrLoading;
  } else if (
    paramsOrLoading !== undefined &&
    paramsOrLoading !== null &&
    typeof paramsOrLoading === "object"
  ) {
    params = complaintListParams(paramsOrLoading);
    if (typeof maybeLoading === "boolean") isLoading = maybeLoading;
  }

  return (dispatch) => {
    dispatch({
      type: GET_COMPLAINTS_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get(`/complaints`, { params })
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          const payload = response.data;
          const normalized = Array.isArray(payload)
            ? { items: payload, total: payload.length }
            : {
                items: payload.items ?? [],
                total: payload.total ?? (payload.items?.length ?? 0),
              };

          dispatch({
            type: GET_COMPLAINTS_RESPONSE,
            isLoading: false,
            response: normalized,
            error: error,
          });
        } else {
          dispatch({
            type: GET_COMPLAINTS_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch(setSnackbar(true, "error", `Failed to retrieve complaints: ${error.toString()}.`));
        dispatch({
          type: GET_COMPLAINTS_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}

/** Sidebar SLA dots — counts independent of list filters */
export function getComplaintSlaBadgeCounts() {
  return (dispatch) =>
    axios.get(`/complaints/sla-badges`).then((response) => {
      dispatch({
        type: GET_COMPLAINT_SLA_BADGES_RESPONSE,
        response: response.data || { overdue: 0, warning: 0 },
      });
    });
}

export function updateComplaint(uuid, body, isLoading = true) {
  body.uuid = uuid;
  return (dispatch) => {
    dispatch({
      type: UPDATE_COMPLAINT_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .put(`/complaint/${uuid}`, body)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          dispatch({
            type: UPDATE_COMPLAINT_RESPONSE,
            isLoading: false,
            response: response.data,
            error: error,
          });
          dispatch(setSnackbar(true, "success", `Successfully updated complaint: ${response.data.complaintTitle}.`));
        } else {
          dispatch({
            type: UPDATE_COMPLAINT_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_COMPLAINT_FAILURE,
          isLoading: false,
          error: error,
        });
        dispatch(setSnackbar(true, "error", `Failed to update complaint.`));
      });
  };
}

export function createComplaint(body, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: CREATE_COMPLAINT_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .post(`/complaint`, body)
      .then((response) => {
        if (response.status == 200) {
          dispatch(setSnackbar(true, "success", `Successfully created complaint: ${body.complaintTitle}.`));
          dispatch({
            response: response.data,
            type: CREATE_COMPLAINT_RESPONSE,
          });
          return response.data;
        }
      })
      .catch((error) => {
        dispatch(setSnackbar(true, "error", `Failed to create complaint.`));
        dispatch({
          type: CREATE_COMPLAINT_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getComplaintNotesByComplaintId(complaintId) {
  return (dispatch) => {
    dispatch({ type: GET_COMPLAINT_NOTES_REQUEST, isLoading: true });
    return axios
      .get(`/complaintnote/complaint/${complaintId}`)
      .then((response) => {
        dispatch({
          type: GET_COMPLAINT_NOTES_RESPONSE,
          isLoading: false,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_COMPLAINT_NOTES_FAILURE, isLoading: false, error });
      });
  };
}

export function createComplaintNote(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_COMPLAINT_NOTE_REQUEST, isLoading: true });
    return axios
      .post(`/complaintnote`, body)
      .then((response) => {
        dispatch({
          type: CREATE_COMPLAINT_NOTE_RESPONSE,
          isLoading: false,
          response: response.data,
        });
        dispatch(setSnackbar(true, "success", "Note added successfully."));
      })
      .catch((error) => {
        dispatch({ type: CREATE_COMPLAINT_NOTE_FAILURE, isLoading: false, error });
        dispatch(setSnackbar(true, "error", "Failed to add note."));
      });
  };
}

export function getComplaintFilesByComplaintId(complaintId) {
  return (dispatch) => {
    dispatch({ type: GET_COMPLAINT_FILES_REQUEST, isLoading: true });
    return axios
      .get(`/complaintfile/complaint/${complaintId}`)
      .then((response) => {
        dispatch({
          type: GET_COMPLAINT_FILES_RESPONSE,
          isLoading: false,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_COMPLAINT_FILES_FAILURE, isLoading: false, error });
      });
  };
}

export function createComplaintFile(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_COMPLAINT_FILE_REQUEST, isLoading: true });
    return axios
      .post(`/complaintfile`, body)
      .then((response) => {
        dispatch({
          type: CREATE_COMPLAINT_FILE_RESPONSE,
          isLoading: false,
          response: response.data,
        });
        dispatch(setSnackbar(true, "success", "File uploaded successfully."));
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: CREATE_COMPLAINT_FILE_FAILURE, isLoading: false, error });
        dispatch(setSnackbar(true, "error", "Failed to upload file."));
      });
  };
}

export function deleteComplaintFile(uuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_COMPLAINT_FILE_REQUEST, isLoading: true });
    return axios
      .delete(`/complaintfile/${uuid}`)
      .then((response) => {
        dispatch({
          type: DELETE_COMPLAINT_FILE_RESPONSE,
          isLoading: false,
          uuid: uuid,
        });
        dispatch(setSnackbar(true, "success", "File deleted."));
      })
      .catch((error) => {
        dispatch({ type: DELETE_COMPLAINT_FILE_FAILURE, isLoading: false, error });
        dispatch(setSnackbar(true, "error", "Failed to delete file."));
      });
  };
}

export function getComplaintStatuses() {
  return (dispatch) => {
    dispatch({ type: GET_COMPLAINT_STATUSES_REQUEST, isLoading: true });
    return axios
      .get(`/complaintstatus`)
      .then((response) => {
        dispatch({
          type: GET_COMPLAINT_STATUSES_RESPONSE,
          isLoading: false,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_COMPLAINT_STATUSES_FAILURE, isLoading: false, error });
      });
  };
}

export function getComplaintTypes() {
  return (dispatch) => {
    dispatch({ type: GET_COMPLAINT_TYPES_REQUEST, isLoading: true });
    return axios
      .get(`/complainttype`)
      .then((response) => {
        dispatch({
          type: GET_COMPLAINT_TYPES_RESPONSE,
          isLoading: false,
          response: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_COMPLAINT_TYPES_FAILURE, isLoading: false, error });
      });
  };
}
